L.Attribution = L.Class.extend({
    includes: L.Mixin.Events,

    options: {
        text: "Custom Attribution Text",
        viewport: {
            height: 200,
            width: 200
        },
        companyName: 'Company Name'
    },

    initialize: function (options) {
        L.Util.setOptions(this, options);

        var year = new Date().getFullYear();
        this.text = '&copy; ' + this.options.companyName + ' ' + this.options.text;
        this.viewport = this.options.viewport;
    },

    addTo: function (map) {
        this.map = map;
        this._createElements();
        this._render();
        return this;
    },

    remove: function () {
        if (this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
        }
    },
    
    getHeight: function () {
        return parseInt(L.DomUtil.getStyle(this._container, "height"));
    },
    
    update: function (dimensions) {
        this.viewport = this.options.viewport = dimensions;
        this._render();
    },

    _createElements: function () {
        if (!!this._container)
            return;
        
        this._container = L.DomUtil.create("div", "leaflet-attribution-container", this.map._controlContainer);
        this._text = L.DomUtil.create("div", "leaflet-attribution", this._container);
        this._text.innerHTML = this.text;
        
        this.map.on("resize", this._onMapResize, this);
    },

    _onMapResize: function () {
        this._render();
    },

    _render: function () {
        var size = this.map.getSize();
        var bottom = Math.round((size.y - this.viewport.height) / 2);
        var left = Math.round((size.x - this.viewport.width) / 2);

        this._container.style.bottom = bottom + 'px';
        this._container.style.left = left + 'px';
        this._container.style.width = this.viewport.width + 'px';
    }
});

L.attribution = function (options) {
    return new L.Attribution(options);
};
define("leaflet-attribution", function(){});

